import { DependencyList, useEffect } from "react";

export const useDebouncedEffect = (
  effect: () => void | (() => void) | Promise<void> | (() => Promise<void>), // Effect can optionally return a cleanup function
  deps: DependencyList = [], // Default deps to an empty array
  delay: number,
): void => {
  useEffect(() => {
    const handler = setTimeout(() => effect(), delay);

    return () => clearTimeout(handler);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay, ...deps]);
};
